import script from "./TextInputSingleValue.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextInputSingleValue.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__